import React from 'react'
import { useModel, objectVariantOrPassthrough, initControls, setControlVal } from '../../../lib/state'
import stateVariants from './variants'

import { useApi_OrgId_AppId } from '../../../lib/hooks'

///////////
// MODEL //
///////////

const model = {
  ///////////
  // STATE //
  ///////////
  stateInit(args) {
    const _ = objectVariantOrPassthrough(stateVariants, args)

    let ret = {
      ..._,
      _doUpdateCredsToken: undefined,
      pushPlatform: 'firebase',
      _afterValidateAll: (state) => {
        if (state.trySaveOnNextValidate) {
          state.trySaveOnNextValidate = false
          if (state.isValid) {
            state._doUpdateCredsToken = Math.random()
          }
        }
      },
    }

    ret.controls = {
      serverKey: {
        defaultVal: '',
        methodKey: 'setServerKey',
        _validator: (val) => {
          return (val && val !== '') || 'Server key is required'
        },
        _validateAllowNotChanged: false,
      },
    }

    initControls(ret)
  
    return ret
  },
  /////////////
  // METHODS //
  /////////////
  methodsInit(state) {
    return {
      setServerKey(val, opts) {
        setControlVal(state, state.controls.serverKey, val)
      },
      doUpdateCreds(val, opts) {
        state.shouldValidate = true
        state.trySaveOnNextValidate = true
        state.data = {
          serverKey: state.controls.serverKey.val
        }
        setControlVal(state)
      },
      setOnCompletedCallback(val, opts) {
        state._onCompleted = val
      },
    }
  },
  ///////////
  // HOOKS //
  ///////////
  hooks: {
    useUpdateApplicationPushCredentials: {
      useHook: (state, methods) => {
        const {
          _doUpdateCredsToken,
          _onCompleted,
          data,
          pushPlatform,
        } = state
  
        const [ api, organizationId, appId ] = useApi_OrgId_AppId()
  
        React.useEffect(() => {
          if (_doUpdateCredsToken >= 0) {
            api({
              method: 'post',
              url: '/saas/v1/notifications/v1/updateApplicationPushCredentials',
              data: {
                pushPlatform,
                appId,
                organizationId,
                data,
              },
              handler: (res) => {
                if (_onCompleted) _onCompleted()
              },
            })
          }
          
        }, [
          _doUpdateCredsToken,
          _onCompleted,
          pushPlatform,
          data,
          api,
          organizationId,
          appId,
        ])
      },
    }
  }
}
export default (stateInitializerArgs) => {
  return useModel(model, stateInitializerArgs)
}